export enum VALID_ROUTES {
  HOME = 'home',
  CATALOG = 'catalog',
  FAVORITES = 'favorites',
  LOGIN = 'login',
  PASSWORD_RESET = 'password-reset',
  REGISTER = 'register',
  ACCOUNT = 'account',
  CONTACT_US = 'contact-us',
  HOW_TO_HELP = 'how-to-help',
  PARTNER_WITH_US = 'partner-with-us',
  UNSUBSCRIBE = 'unsubscribe',
}
